import { TxModalContext } from "@contexts/TxModalContext";
import { useContext } from "react";

export function useTxModal() {
    const context = useContext(TxModalContext)

    return {
        show: context.show,
        hide: context.hide
    }
}